module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/thumbs/4-482d236bc84afbb6fcc35761e35306cd.webp";